import { Injectable, OnDestroy, computed, signal } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class FuseProgressBarService implements OnDestroy {
    apiCount = signal<number>(0);
    bufferValue = signal<number>(0);
    mode = signal<'determinate' | 'indeterminate' | 'buffer' | 'query'>('indeterminate');
    value = signal<number>(0);
    visible = computed(() => this.apiCount() > 0);

    setBufferValue(value: number): void {
        this.bufferValue.set(value);
    }

    setMode(value: 'determinate' | 'indeterminate' | 'buffer' | 'query'): void {
        this.mode.set(value);
    }

    setValue(value: number): void {
        this.value.set(value);
    }

    /**
     * Show the progress bar
     */
    show(_mode?: 'determinate' | 'indeterminate' | 'buffer' | 'query'): void {
        this.apiCount.update(oldValue => ++oldValue);
        if (_mode) {
            this.mode.set(_mode ? _mode : 'query');
        }
    }

    /**
     * Hide the progress bar
     */
    hide(): void {
        this.apiCount.update(oldValue => (oldValue > 0 ? --oldValue : 0));
    }

    ngOnDestroy() {
        this.apiCount.update(() => 0);
    }
}
